import {
  ADD_DELIVERY_NOTIFICATION,
  ADD_FLEET_NOTIFICATION,
  REMOVE_DELIVERY_NOTIFICATION,
  REMOVE_FLEET_NOTIFICATION,
} from '../actions/notification.actions'

const initialNotificationState = {
  fleets_ids: [],
  deliveries_ids: [],
}

export default function (state = initialNotificationState, action) {
  switch (action.type) {
    case ADD_DELIVERY_NOTIFICATION:
      return {
        ...state,
        deliveries_ids: [...state.deliveries_ids, action.delivery_id],
      }
    case REMOVE_DELIVERY_NOTIFICATION:
      return {
        ...state,
        deliveries_ids: state.deliveries_ids.filter(delivery => delivery !== action.delivery_id),
      }
    case ADD_FLEET_NOTIFICATION:
      return {
        ...state,
        fleets_ids: [...state.fleets_ids, action.fleet_id],
      }
    case REMOVE_FLEET_NOTIFICATION:
      return {
        ...state,
        fleets_ids: state.fleets_ids.filter(fleet => fleet !== action.fleet_id),
      }
    default:
      return state
  }
}
